module.exports = __webpack_public_path__ + "img/inspiring_background@2x.9abd3be.jpg";